import { cn } from '@/shared/lib/utils'

function Badge({ className, ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-transparent bg-secondary px-2.5 py-1 text-xs font-semibold text-secondary-foreground',
        className,
      )}
      {...props}
    />
  )
}

export { Badge }
